
function SkillTag({ skill }) {
  return (
    <span className="bg-gray-800 text-neon px-4 py-2 rounded-full text-sm font-medium border border-neon hover:bg-neon hover:text-black transition-transform transform hover:scale-105 duration-200 focus:outline-none focus:ring-2 focus:ring-neon">
      {skill}
    </span>
  );
}

export default SkillTag;